import React from 'react';
import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';
import { Send, Download, Copy, Ban, CheckCircle2, Clock, Mail, MessageSquare, Sparkles } from 'lucide-react';
export function GeneratedDocumentDetailPage() {
  const {
    documentId
  } = useParams();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-7xl mx-auto h-[calc(100vh-8rem)] flex flex-col" data-id="element-3523">
      {/* Header */}
      <div className="bg-surface border border-border rounded-xl p-6 mb-6 shrink-0" data-id="element-3524">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-3525">
          <div data-id="element-3526">
            <div className="flex items-center gap-3 mb-2" data-id="element-3527">
              <h1 className="text-2xl font-bold" data-id="element-3528">
                Performance Contract - The Empty Bottle
              </h1>
              <span className="px-2 py-1 bg-amber-500/10 text-amber-500 text-xs rounded font-medium" data-id="element-3529">
                Out for Signature
              </span>
            </div>
            <div className="flex flex-wrap items-center gap-4 text-sm text-textMuted" data-id="element-3530">
              <span data-id="element-3531">Type: Contract</span>
              <span data-id="element-3532">Linked: Jun 12 Show</span>
              <span data-id="element-3533">Version: v1</span>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-3534">
            <button className="p-2 bg-surface border border-border rounded-lg hover:bg-surfaceHover transition-colors text-textMuted" title="Mark Obsolete" data-id="element-3535">
              <Ban className="w-5 h-5" data-id="element-3536" />
            </button>
            <button className="p-2 bg-surface border border-border rounded-lg hover:bg-surfaceHover transition-colors text-textMuted" title="Duplicate" data-id="element-3537">
              <Copy className="w-5 h-5" data-id="element-3538" />
            </button>
            <button className="px-4 py-2 bg-surface border border-border rounded-lg hover:bg-surfaceHover transition-colors text-sm font-medium flex items-center gap-2" data-id="element-3539">
              <Download className="w-4 h-4" data-id="element-3540" /> Download PDF
            </button>
            <button className="px-4 py-2 bg-primary text-background rounded-lg hover:bg-primaryHover transition-colors text-sm font-medium flex items-center gap-2" data-id="element-3541">
              <Send className="w-4 h-4" data-id="element-3542" /> Send Reminder
            </button>
          </div>
        </div>
      </div>

      {/* Three-column Layout */}
      <div className="flex-1 flex gap-6 min-h-0" data-id="element-3543">
        {/* Left Column: Signer Timeline */}
        <div className="w-72 shrink-0 flex flex-col gap-6 overflow-y-auto" data-id="element-3544">
          <div className="bg-surface border border-border rounded-xl p-6" data-id="element-3545">
            <h3 className="font-semibold mb-4" data-id="element-3546">Signer Status</h3>
            <div className="space-y-6" data-id="element-3547">
              <div className="relative" data-id="element-3548">
                <div className="absolute left-[11px] top-6 bottom-0 w-px bg-border" data-id="element-3549"></div>
                <div className="flex items-start gap-4" data-id="element-3550">
                  <div className="w-6 h-6 rounded-full bg-green-500/20 border-2 border-green-500 flex items-center justify-center shrink-0 z-10" data-id="element-3551">
                    <CheckCircle2 className="w-3 h-3 text-green-500" data-id="element-3552" />
                  </div>
                  <div data-id="element-3553">
                    <p className="text-sm font-medium" data-id="element-3554">Mark Johnson (Artist)</p>
                    <p className="text-xs text-green-500 mt-1" data-id="element-3555">
                      Signed • Jun 1, 10:00 AM
                    </p>
                  </div>
                </div>
              </div>
              <div className="relative" data-id="element-3556">
                <div className="flex items-start gap-4" data-id="element-3557">
                  <div className="w-6 h-6 rounded-full bg-surface border-2 border-amber-500 flex items-center justify-center shrink-0 z-10" data-id="element-3558">
                    <Clock className="w-3 h-3 text-amber-500" data-id="element-3559" />
                  </div>
                  <div data-id="element-3560">
                    <p className="text-sm font-medium" data-id="element-3561">Brent Heyl (Venue)</p>
                    <p className="text-xs text-amber-500 mt-1" data-id="element-3562">
                      Viewed • Jun 2, 2:15 PM
                    </p>
                    <button className="mt-2 text-xs font-medium text-primary hover:underline" data-id="element-3563">
                      Send Reminder
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Center Column: Document Preview */}
        <div className="flex-1 bg-surface border border-border rounded-xl overflow-hidden flex flex-col" data-id="element-3564">
          <div className="flex-1 p-8 overflow-y-auto bg-background/30 flex justify-center" data-id="element-3565">
            <div className="w-full max-w-2xl bg-surface border border-border rounded shadow-sm min-h-full p-12 font-serif text-sm leading-relaxed" data-id="element-3566">
              <h1 className="text-xl font-bold text-center mb-8" data-id="element-3567">
                PERFORMANCE AGREEMENT
              </h1>
              <p className="mb-4" data-id="element-3568">
                This Performance Agreement (the "Agreement") is entered into as
                of June 1, 2026, by and between:
              </p>
              <p className="mb-4" data-id="element-3569">
                <strong data-id="element-3570">ARTIST:</strong> The Wildwoods
                <br data-id="element-3571" />
                <strong data-id="element-3572">VENUE/PROMOTER:</strong> The Empty Bottle
              </p>
              <p className="mb-4" data-id="element-3573">
                The Venue hereby engages the Artist to perform at The Empty
                Bottle located at 1035 N Western Ave, Chicago, IL on June 12,
                2026.
              </p>
              <div className="mt-16 grid grid-cols-2 gap-8" data-id="element-3574">
                <div data-id="element-3575">
                  <div className="border-b border-border pb-1 mb-2 font-handwriting text-xl text-textMuted" data-id="element-3576">
                    Mark Johnson
                  </div>
                  <div className="text-xs font-sans" data-id="element-3577">Artist Signature</div>
                </div>
                <div data-id="element-3578">
                  <div className="border-b border-border pb-1 mb-2 h-8 bg-amber-500/10 border-amber-500/30 border border-dashed rounded flex items-center justify-center text-amber-500 text-xs font-sans" data-id="element-3579">
                    Awaiting Signature
                  </div>
                  <div className="text-xs font-sans" data-id="element-3580">Venue Signature</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: AI & Activity */}
        <div className="w-80 shrink-0 flex flex-col gap-6 overflow-y-auto" data-id="element-3581">
          <div className="bg-primary/10 border border-primary/20 rounded-xl p-5" data-id="element-3582">
            <div className="flex items-center gap-2 mb-3" data-id="element-3583">
              <Sparkles className="w-4 h-4 text-primary" data-id="element-3584" />
              <h3 className="font-semibold text-primary" data-id="element-3585">AI Summary</h3>
            </div>
            <ul className="text-sm space-y-2 text-textMuted" data-id="element-3586">
              <li data-id="element-3587">• $1,500 Guarantee + 80% after $2k</li>
              <li data-id="element-3588">• 60-mile radius clause (30 days)</li>
              <li data-id="element-3589">• Venue provides backline</li>
            </ul>
          </div>

          <div className="bg-surface border border-border rounded-xl p-5 flex-1" data-id="element-3590">
            <h3 className="font-semibold mb-4 flex items-center gap-2" data-id="element-3591">
              <MessageSquare className="w-4 h-4" data-id="element-3592" /> Comments & Activity
            </h3>
            <div className="space-y-4" data-id="element-3593">
              <div className="flex gap-3" data-id="element-3594">
                <div className="w-8 h-8 rounded-full bg-primary/20 text-primary flex items-center justify-center text-xs font-bold shrink-0" data-id="element-3595">
                  M
                </div>
                <div data-id="element-3596">
                  <div className="bg-background border border-border rounded-lg p-3 text-sm" data-id="element-3597">
                    I've signed this. Waiting on Brent.
                  </div>
                  <span className="text-xs text-textMuted mt-1" data-id="element-3598">
                    Jun 1, 10:05 AM
                  </span>
                </div>
              </div>
              <div className="flex gap-3" data-id="element-3599">
                <div className="w-8 h-8 rounded-full bg-surface border border-border flex items-center justify-center shrink-0" data-id="element-3600">
                  <Mail className="w-4 h-4 text-textMuted" data-id="element-3601" />
                </div>
                <div data-id="element-3602">
                  <p className="text-sm" data-id="element-3603">Reminder email sent to Brent Heyl</p>
                  <span className="text-xs text-textMuted" data-id="element-3604">Jun 3, 9:00 AM</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}